import { render, staticRenderFns } from "./Hero2Background.vue?vue&type=template&id=94c98932&scoped=true&"
import script from "./Hero2Background.vue?vue&type=script&lang=js&"
export * from "./Hero2Background.vue?vue&type=script&lang=js&"
import style0 from "./Hero2Background.vue?vue&type=style&index=0&id=94c98932&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c98932",
  null
  
)

export default component.exports